<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <yq-date-range v-model:start-time="searchInfo.startTime" v-model:end-time="searchInfo.endTime" class="double-width">
            <template #prefix>订单时间</template>
          </yq-date-range>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
<!--          <page-button type="write" el-type="success" @click="toAddNew">新建</page-button>-->
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border >
          <yq-table-column  label="名称" prop="merchantName" min-width="180rem"/>
          <yq-table-column label="订单id" prop="qywxOrderId" min-width="180rem"/>
          <yq-table-column label="账号类型" prop="accountType" >
            <template v-slot="{row}">
              {{row.accountType === 1 ? "基础账号" : "互通账号"}}
            </template>
          </yq-table-column>
          <yq-table-column label="账号数量" prop="accountNumber" />
          <yq-table-column label="账号时长" prop="accountDuration" >
            <template v-slot="{row}">
              {{row.accountDuration}} 个月
            </template>
          </yq-table-column>
          <yq-table-column label="订单时间" prop="createdTime"/>
          <yq-table-column  label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button @click="toDetail(row)">管理</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
    <el-dialog v-model="showAddNew" title="创建企业微信订单" dialog-width="1">
      <form-items :data="currentData" :columns="1" label-width="2.4rem" ref="addNewData">
        <form-item label="商户名称" :required="true" name="merchantId" error-message="请选择商户">
          <el-select v-model="currentData.merchantId" clearable filterable placeholder="请选择商户">
            <el-option v-for="item in merchantList" :label="item.merchantName" :value="item.id" :key="item.id"/>
          </el-select>
        </form-item>
        <form-item label="账号类型" :required="true" name="accountType" error-message="请选择账号类型">
          <el-select v-model="currentData.accountType" clearable filterable placeholder="请选择账号类型">
            <el-option label="基础账号" :value="1"/>
            <el-option label="互通账号" :value="2"/>
          </el-select>
        </form-item>
        <form-item label="账号数量" :required="true" name="accountNumber" error-message="请填写账号数量">
          <el-input v-model="currentData.accountNumber" placeholder="请填写账号数量"/>
        </form-item>
        <form-item label="账号时长" :required="true" name="accountDuration" error-message="请填写账号时长">
          <el-select v-model="currentData.accountDuration" placeholder="请填写账号时长">
            <el-option label="1个月" :value="1"/>
            <el-option label="12个月" :value="12"/>
          </el-select>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showAddNew = false">取消</page-button>
        <page-button el-type="primary" @click="saveData">确定</page-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import commonApi from "@/api/commonApi";
import qywxOrderApi from "@/api/normal/sys/qywxOrderApi";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import YqDateRange from "@/components/h5/date/YqDateRange.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "QOL",
  components: {
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage, FormItems, FormItem, YqDateRange
  },
  data() {
    return {
      searchInfo: {},
      dataList: [{}],
      merchantList: [],
      showAddNew: false,
      currentData: {},
      userInfo: {}
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
      commonApi.queryAllMerchants().then(res => {
        this.merchantList = res;
      })
      // 查询登录人员信息
      Util.getUserInfo().then(user => {
        this.userInfo = user;
        this.searchInfo.merchantId = user.merchantId;
        this.resetSearch();
      })

    }
  },
  methods: {
    queryList() {
      qywxOrderApi.queryQywxOrderList(this.searchInfo).then(res => {
        this.dataList = res.records;
        this.searchInfo.totalCount = res.totalCount;
      });
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toAddNew() {
      this.currentData = {};
      this.showAddNew = true;
    },
    saveData() {
      if (!this.$refs.addNewData.validCheck()) {
        return;
      }
      qywxOrderApi.sendApply(this.currentData).then(() => {
        this.showAddNew = false;
        this.queryList();
      });
    },
    toDetail(data) {
      this.router.push(`/order/qywx/detail?id=${data.id}`)
    }
  }
};
</script>

<style lang="scss" scoped>
</style>